export const RouteGetMerchflows_merchflowId_S0_s0SolutionId_logs =
  "/merchflows/:merchflowId/s0/:s0SolutionId/logs";

export type ResponseGetMerchflows_merchflowId_S0_s0SolutionId_logs = {
  algo_request: unknown | null;
  algo_response: unknown | null;
};
